import { api } from "./../app";
export const getObjectMetadata = params => {
	params.reqId = "b9ae948b-27b1-4363-9f9b-edf53eb2fee4";
	// s3ObjectMetadataPvt
	return new Promise(async (resolve, reject) => {
		try {
			const response = await $.ajax({
				method: "POST",
				url: `${api}/request`,
				contentType: "application/json",
				xhrFields: {
					withCredentials: true
				},
				data: JSON.stringify(params)
			});
			if (response.success) {
				resolve(response.data);
			} else throw response.data;
		} catch (err) {
			reject(err);
		}
	});
};
